import { http } from './httpService';

/**
 * A hint for Paddle.PricePreview, not an identity check: called anonymously,
 * by signed-in and signed-out visitors alike, from the pricing page.
 */
export const GeoService = {
  country: () => http.get<{ country: string | null }>('/geo/country', { anonymous: true })
};
